export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/enums/CartItemType.ts